import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

const ANTIBODY_BETA_FEEDBACK_FORM = 'https://forms.gle/67i1WiTYjKMxsh7C8';

/**
 * Render a banner for soliciting beta feedback for the antibody feature.
 */
export default function AntibodyFeedbackBanner(): JSX.Element {
  if (BenchlingConfig.MOLBIO_HIDE_ANTIBODY_FEEDBACK_BANNER) {
    return <></>;
  }
  return (
    <InlineBanner
      bannerType={InlineBannerType.BETA}
      hideIcon={true}
      text={
        <>
          Antibodies are a new beta feature.{' '}
          <a href={ANTIBODY_BETA_FEEDBACK_FORM} target="_blank" rel="noreferrer">
            Share feedback
          </a>
        </>
      }
    />
  );
}
